import { Progress } from "@/components/Progress/Progress";
import { TableCell } from "@/components/ui/table";
import { cn } from "@/lib/cn";

import type { TableRowData } from "./types";

interface ProgressCellProps {
  row: TableRowData;
  rowIndex: number;
  hoveredRowIndex: number | null;
  handleCellMouseEnter: (rowIndex: number, colIndex: number) => void;
}

export const ProgressCell = ({
  row,
  rowIndex,
  hoveredRowIndex,
  handleCellMouseEnter,
}: ProgressCellProps) => {
  return (
    <TableCell
      className={cn(
        "p-2 border-r border-neutral-border w-fit sticky left-32 z-10",
        hoveredRowIndex === rowIndex ? "bg-neutral-gray-light-3" : "bg-white",
      )}
      onMouseEnter={() => handleCellMouseEnter(rowIndex, 1)}
    >
      <Progress
        total={row.totalOperationStepCount}
        completed={row.completedOperationStepCount}
        size="small"
        segmentLength={5}
      />
    </TableCell>
  );
};
